import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { COOKIE_NAME, DATANYZE_DOMAIN, SameSite, TERMS_OF_SERVICE } from './cookie.consent.config';
import { popInAndOut } from './popup.animation';
import { MarketingSize } from '../buttons/dn-markting-btn/marketing-btn.config';

@Component({
  selector: 'dn-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
  animations: [popInAndOut],
  standalone: false,
})
export class CookieConsentComponent implements OnInit {
  constructor(private readonly cookieService: CookieService) {}
  @Input() baseUrl: string;
  @Output() onUserAction: EventEmitter<any> = new EventEmitter<any>();
  buttonSizes = MarketingSize;
  showBanner = true;
  hideBannerAfterClick: boolean;

  ngOnInit(): void {
    if (!this.baseUrl) {
      throw Error('No base Url');
    } else {
      this.cookieConsentCheck();
    }
  }

  get termsUrl(): string {
    return `${this.baseUrl}/${TERMS_OF_SERVICE}`;
  }

  cookieConsentCheck(): void {
    const existingCookie = this.cookieService.get(COOKIE_NAME);
    if (existingCookie && existingCookie.toLowerCase() === 'true') {
      this.showBanner = false;
    }
  }

  onGotItButtonClick(): void {
    const cookieExpirationInDays = 365;
    const hostDomain = window.location.hostname;
    this.cookieService.set(COOKIE_NAME, 'true', cookieExpirationInDays, '/', DATANYZE_DOMAIN, false, SameSite.LAX);
    if (hostDomain.indexOf(DATANYZE_DOMAIN) < 0) {
      this.cookieService.set(COOKIE_NAME, 'true', cookieExpirationInDays, '/', hostDomain, false, SameSite.LAX);
    }
    this.showBanner = false;
    this.onUserAction.emit();
  }
}
